import { FC } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Link,
} from "@mui/material";

interface IListUIProps {
  steps: Array<any>;
}

export const ListUI: FC<IListUIProps> = (props) => {
  return (
    <List sx={{ maxWidth: 500 }}>
      {props.steps.map((step, index) => (
        <ListItem key={index} alignItems="flex-start">
          <ListItemIcon sx={{ minWidth: 40 }}>{step.icon}</ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="subtitle1" fontWeight="bold">
                {step.title}
              </Typography>
            }
            secondary={
              <Typography variant="body2" color="text.secondary">
                {step.description}
              </Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};
